import { useIntercom } from "react-use-intercom";

import { getWhitelabelCustomization } from "common/helpers/utils";
import NavItem from "common/layouts/WorkspaceLayout/NavItem";

import TooltipNavItem from "./TooltipNavItem";

import IntercomIcon from "assets/icons/intercom.svg?react";

export default function ExtraNavItems({ isExpanded }: { isExpanded: boolean }) {
  const { show } = useIntercom();

  const label = "Support live chat";

  if (!getWhitelabelCustomization()) {
    return (
      <TooltipNavItem
        component={
          <button type="button" onClick={show}>
            <NavItem isExpanded={isExpanded} icon={<IntercomIcon />}>
              {label}
            </NavItem>
          </button>
        }
        isExpanded={isExpanded}
        label={label}
      />
    );
  }
}
